var map = {
	"./Benchmark.jpg": 100,
	"./Digital globe.jpg": 101,
	"./Final1.jpg": 102,
	"./Multimodal.jpg": 103,
	"./RightPartner3.jpg": 104,
	"./bidirectional.jpg": 105,
	"./logo-lorri.png": 28,
	"./logo.png": 106,
	"./logo3.png": 107,
	"./mid_image.jpg": 29,
	"./myTransporter-banner.jpg": 108,
	"./plus-icon.svg": 109,
	"./search-glass.jpg": 110,
	"./shell.jpg": 48,
	"./transporter.jpg": 111,
	"./transporter_logo.png": 20,
	"./upper_part.jpg": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;